<header>
  <nav class="menu navbar navbar-expand-md navbar-toggleable-md navbar-light bg-white border-bottom mb-5">
    <div class="container">
      <a class="navbar-brand" [routerLink]="['/']">
        <img srcset="
          /assets/knight-frank.png 1x,
          /assets/knight-frank@2x.png 2x,
          /assets/knight-frank@3x.png 3x
          " alt="Knight Frank" class="logo logo-kf">
        <img srcset="
          /assets/vision-insights.png 1x,
          /assets/vision-insights@2x.png 2x,
          /assets/vision-insights@3x.png 3x
          " alt="Vision Insights" class="logo logo-vs">
      </a>

      <ul class="navbar-nav" *ngIf="!isExpanded">
        <li class="nav-item" [routerLinkActive]="['link-active']">
          <a class="nav-link text-dark" [routerLink]="['/reports']">
            <fa-icon [icon]="faPoll" class="me-1"></fa-icon> Reports
          </a>
        </li>
        <li class="nav-item" [routerLinkActive]="['link-active']">
          <a class="nav-link text-dark" [routerLink]="['/help']">
            <fa-icon [icon]="faQuestionSquare" class="me-1"></fa-icon> Help
          </a>
        </li>
      </ul>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse"
        aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="navbar-collapse collapse d-md-inline-flex justify-content-end" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav">
          <li class="nav-item" [routerLinkActive]="['link-active']" *ngIf="isExpanded">
            <a class="nav-link text-dark" [routerLink]="['/reports']">
              <fa-icon [icon]="faPoll" class="me-1"></fa-icon> Reports
            </a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" *ngIf="isExpanded">
            <a class="nav-link text-dark" [routerLink]="['/help']">
              <fa-icon [icon]="faQuestionSquare" class="me-1"></fa-icon> Help
            </a>
          </li>
          <ng-container *ngIf="['ClientAdministrator', 'Administrator'] | hasRole | async">
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link text-dark" [routerLink]="['/administration']">
                <fa-icon [icon]="faCog" class="me-1"></fa-icon> Administration
              </a>
            </li>
          </ng-container>
          <li class="nav-item">
            <a class="nav-link text-dark" [routerLink]='["/logout"]' title="Logout">
              <fa-icon [icon]="faSignOutAlt" class="me-1"></fa-icon> Logout
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
